import { useEffect, useRef } from 'react'
import usePlanMetrics from './usePlanMetrics'
import { toGlobalParams } from './planMetricsParams'

/**
 * Story 175 (CU8/CU12, contract §2) -- the delivery of every fabrication order of the plan and its four
 * counts, built on `usePlanMetrics` so it inherits the 400 ms debounce and the "only the latest answer
 * paints" discard (RN53/P4).
 *
 * Consumers: the counters of the details table (J2) and the late border of the Gantt (J3). Both ask with
 * the Planner's applied global filters only (RN33: never the table's "Asset" selector, status filter,
 * search or page), so the same filters always give the same figures as the ribbon (RN2).
 *
 * - RN52: nothing is requested while `enabled` is false (the caller is folded) or without a plan.
 * - RN51: `metricsVersion` is the Planner's "the plan changed" signal; a bump re-reads the same filters.
 */
const useDeliveries = ({ planificationId, plannerFilters, metricsVersion = 0, enabled = true }) => {
  const { data, loading, error, reload } = usePlanMetrics({
    planificationId,
    endpoint: 'deliveries',
    params: toGlobalParams(plannerFilters),
    enabled
  })

  const isFirstMetricsVersionRender = useRef(true)
  useEffect(() => {
    if (isFirstMetricsVersionRender.current) {
      isFirstMetricsVersionRender.current = false
      return
    }
    reload()
  }, [metricsVersion, reload])

  return { data, loading, error, reload }
}

export default useDeliveries
